import { GridColDef } from "@mui/x-data-grid";
import { IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

type Props = {
  onActionEditar: (idControleEnergia: number, openState: boolean) => void;
  onActionDeletar: (idControleEnergia: number, openState: boolean) => void;
};

export const GenerateEnergiaColumnDefinition = ({ onActionEditar, onActionDeletar }: Props): GridColDef[] => {
  return [
    { field: "ano", headerName: "Ano", width: 70 },
    { field: "mes", headerName: "Mês", width: 100 },
    { field: "kwH", headerName: "KW/H", width: 100 },
    {
      field: "valor",
      filterable: false,
      headerName: "Valor",
      flex: 1,
      minWidth: 120,
      sortable: false,
      valueFormatter: (params) => {
        if (params == null) return "";
        return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(params);
      },
    },
    { field: "diasMedicao", headerName: "Dias de Medição", width: 130 },
    { field: "efetivoMes", headerName: "Efetivo do Mês", width: 130 },
    { field: "mediaTrabalhador", headerName: "Média Por Trabalhador (KW/H)", width: 180 },
    { field: "areaConstruida", headerName: "Área Construída (M²)", width: 150 },
    { field: "mediaArea", headerName: "Média Por Área (M²)", width: 150 },
    { field: "metaAprovacao", headerName: "Meta Aprovação", width: 130 },
    { field: "observacao", headerName: "Observação", flex: 1, minWidth: 150 },
    {
      field: "idControleEnergia",
      headerName: "Ações",
      sortable: false,
      filterable: false,
      width: 100,
      renderCell: (params) => (
        <div className="flex items-center justify-center w-full h-full gap-2">
          <IconButton onClick={() => onActionEditar(params.row.idControleEnergia, true)}>
            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
          </IconButton>

          <IconButton onClick={() => onActionDeletar(params.row.idControleEnergia, true)}>
            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
          </IconButton>
        </div>
      ),
    },
  ];
};
